import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ProductSelectorViewModel extends SelectorBaseViewModel<Product> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<Product[]> {
        let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/GetAllSimpleProducts', {})
        return result.Products.map(x => {
            let p = new Product(this);
            p.id = x.Id;
            p.title = `${x.Name} (${x.Code})`;
            return p;
        });
    }
}

export class Product extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}